import { CSSProperties, FC } from 'react';

import { styled } from '../theme';
import BodyText2 from './BodyText2';
import Dropdown from './Dropdown';
import FlexBox from './FlexBox';

const DropdownWrapper = styled.div(({ theme }) => ({
    width: 80,
    zIndex: theme.zIndex.rowsPerPage,
    button: {
        color: theme.color.primary1,
    },
}));

const Label = styled(BodyText2)({
    whiteSpace: 'nowrap',
});

type Props = {
    label: string;
    style?: CSSProperties;
    value: number;
    options?: number[];
    onChange: (ev) => void;
    className?: string;
};

const DEFAULT_OPTIONS = [5, 10, 25];

const RowsPerPageSelector: FC<Props> = ({
    label,
    value,
    options = DEFAULT_OPTIONS,
    onChange,
    className,
    style,
}) => (
    <FlexBox style={style} align="center" gap={8} className={className}>
        <Label>{label}</Label>
        <DropdownWrapper>
            <Dropdown
                id="rows-per-page"
                options={options}
                color="secondary"
                valueMode="single"
                value={value}
                onChange={onChange}
                size="sm"
            />
        </DropdownWrapper>
    </FlexBox>
);

export default RowsPerPageSelector;
